export const TextAnimations = [
    'FadeIn',
    // // 'FadeInDown',
    // 'FadeInUp',
    'ZoomIn',
    'ZoomOut',
    'FlipInX'
    // 'ZoomInUp',
];
const siteFontMapping = {
    Aladin: '/fonts/aladin/Aladin-Regular.ttf',
    Alegreya: '/fonts/alegreya/Alegreya[wght].ttf',
    'Alegrya Sans': '/fonts/alegreyasans/AlegreyaSans[wght].ttf',
    Almendra: '/fonts/almendra/Almendra-Regular.ttf',
    'Anonymous Pro': '/fonts/anonymouspro/AnonymousPro-Regular.ttf',
    'Archivo Narrow': '/fonts/archivonarrow/Archivo[wdth,wght].ttf',
    Arvo: '/fonts/arvo/Arvo-Regular.ttf',
    'Bebas Neue': '/fonts/bebasneue/BebasNeue-Regular.ttf',
    'Berkshire Swash': '/fonts/berkshireswash/BerkshireSwash-Regular.ttf'
};
export const SiteFonts = [
    'Aladin',
    'Alegreya',
    'Alegreya Sans',
    'Almendra',
    'Anonymous Pro',
    'Archivo Narrow',
    'Arvo',
    'Bebas Neue',
    'Berkshire Swash',
    'BioRhyme',
    'Bitter',
    'Cabin',
    'Cardo',
    'Chivo',
    'Coda',
    'Cookie',
    'Cormorant',
    'Courier Prime',
    'Crimson Text',
    'Crushed',
    'Cutive Mono',
    'Dancing Script',
    'Domine',
    'Eczar',
    'Fira Sans',
    'Fjalla One',
    'Fontdiner Swanky',
    'IBM Plex Sans Arabic',
    'Inconsolata',
    'Inknut Antiqua',
    'Inter',
    'Karla',
    'Koulen',
    'Lato',
    'Libre Baskerville',
    'Libre Franklin',
    'Life Savers',
    'Lily Script One',
    'Lobster',
    'Lora',
    'Merriweather',
    'Merriweather Sans',
    'Montserrat',
    'Mulish',
    'Neuton',
    'Oxygen',
    'Oswald',
    'PT Serif',
    'Permanent Marker',
    'Phudu',
    'Playfair Display',
    'Poppins',
    'Proza Libre',
    'PT Mono',
    'Raleway',
    'Red Rose',
    'Roboto Slab',
    'Rock Salt',
    'Rubik',
    'Rye',
    'Space Mono',
    'Spectral',
    'Vast Shadow',
    'Work Sans',
    'Zilla Slab Highlight'
];
export const loadGoogleFontFromSS = async (fontname) => {
    return new Promise((resolve, reject) => {
        if (siteFontMapping[fontname]) {
            const url = 'https://fonts.sermonshots.com' + siteFontMapping[fontname];
            console.log('[sermonshots] loading a google font', fontname, url);
            let font = new FontFace(fontname, `url(${url})`);
            font
                .load()
                .then(() => {
                document.fonts.add(font);
                resolve(font);
            })
                .catch(err => {
                console.warn('Could not load custom font ', font, err);
                reject(err);
            });
        }
        else {
            reject('Font face is not mapped for font ' + fontname);
        }
    });
};
export const FontFamilies = ['default', 'Roboto', 'Open Sans', ...SiteFonts];
